export const RULE = {
  EMAIL:
    /^(?![-_.+])([a-zA-Z0-9-_.+](?![-_.+]{2,}))+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/,
  NUMBER: /^[0-9]*$/,
  JAPANESE: /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[ａ-ｚＡ-Ｚ０-９]+|[々〆〤]/,
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[./+;'[=_)(*&^%$#@!~`<>?":}{|\\\]-]).{8,32}$/,
  LINK: /^https?:\/\//,
  IP: /^(\d{1,3}\.){3}\d{1,3}$/,
  NON_SPACE: /^\S+$/,
  URL: /^rtsp?:\/\//,
  HALFWIDTH_NON_SPACE: /^[A-Za-z0-9]+$/,
  NON_JAPANESE:
    /[\u3040-\u30FF\u4E00-\u9FAF\uFF10-\uFF19\u0021-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E\uFF01-\uFF60\uFFE0-\uFFEE]/,
  SPECIAL: /[`!@#$%^&*()_+\-=[\]{};':"\\|.<>/?~]/,
};
